// eslint-disable-next-line import/prefer-default-export
export const otherLinkURLParams = {
  scheduleAndDetails: 'settings/details',
  grading: 'settings/grading',
  courseTeam: 'course_team',
  advancedSettings: 'settings/advanced',
  groupConfigurations: 'group_configurations',
  proctoredExamSettings: 'proctored-exam-settings',
  studioHome: 'home',
};
